import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { FileText, Lightbulb, CheckCircle } from "lucide-react";

export default function RollingSummaryPanel({ summary = {} }) {
  const { key_points = [], decisions = [], content = "" } = summary;

  if (!content && key_points.length === 0 && decisions.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-gradient-to-r from-amber-50 to-white">
          <FileText className="w-4 h-4 text-amber-500" />
          <h3 className="text-sm font-semibold text-slate-700">Rolling Summary</h3>
        </div>
        <div className="flex flex-col items-center justify-center h-32 text-slate-400">
          <FileText className="w-6 h-6 mb-1 opacity-50" />
          <p className="text-xs">Summary will appear after the meeting progresses</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-gradient-to-r from-amber-50 to-white">
        <FileText className="w-4 h-4 text-amber-500" />
        <h3 className="text-sm font-semibold text-slate-700">Rolling Summary</h3>
      </div>
      <ScrollArea className="h-56 p-4">
        {content && (
          <p className="text-sm text-slate-700 mb-3 leading-relaxed">{content}</p>
        )}
        {key_points.length > 0 && (
          <div className="mb-3">
            <div className="flex items-center gap-1 mb-2">
              <Lightbulb className="w-3 h-3 text-amber-500" />
              <span className="text-xs font-semibold text-slate-600">Key Points</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {key_points.map((pt, i) => (
                <Badge key={i} variant="outline" className="text-[10px] bg-amber-50 text-amber-700 border-amber-200">
                  {pt}
                </Badge>
              ))}
            </div>
          </div>
        )}
        {decisions.length > 0 && (
          <div>
            <div className="flex items-center gap-1 mb-2">
              <CheckCircle className="w-3 h-3 text-green-500" />
              <span className="text-xs font-semibold text-slate-600">Decisions</span>
            </div>
            <ul className="space-y-1">
              {decisions.map((d, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
                  <span className="text-green-500 mt-0.5">•</span>
                  {d}
                </li>
              ))}
            </ul>
          </div>
        )}
      </ScrollArea>
    </div>
  );
}
